import type { Catalog } from "@/api/types";

/**
 * Hodnoty osy varianty, které materiál nabízí PRO TUHLE OPERACI (KAN-2190).
 *
 * Materiál sdílený víc operacemi (plech pro dva dělicí procesy) nese
 * ``variant_axis_values`` sloučené přes všechny — konfigurátor jedné operace
 * pak nabízel tloušťky, které naceňuje a umí jen ta druhá. Server proto posílá
 * i ``variant_axis_values_by_process``: jen hodnoty, které operace naceňuje
 * a které vezme aspoň jeden její stroj. Starší odpověď bez toho pole padá na
 * sloučenou nabídku, jako dřív.
 */
export function offeredAxisValues(
  material: Catalog["materials"][number] | undefined,
  processType: string | undefined,
  axisKey: string | undefined,
): number[] {
  if (!material || !axisKey) return [];
  const byProcess = material.variant_axis_values_by_process;
  if (byProcess && processType) {
    return byProcess[processType]?.[axisKey] ?? [];
  }
  return material.variant_axis_values?.[axisKey] ?? [];
}
